import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

import { UploadCsvComponent } from './upload-csv.component';
import { IconModule } from 'src/app/shared/components/icon/icon.module';
import { InputModule } from 'src/app/shared/components/input/input.module';
import { ButtonModule } from 'src/app/shared/components/button/button.module';

@NgModule({
  declarations: [UploadCsvComponent],
  imports: [
    CommonModule,
    TranslateModule,
    IconModule,
    InputModule,
    ButtonModule,
  ],
  exports: [UploadCsvComponent],
})
export class UploadCsvModule {}
